import React from 'react';

/** Decorative illustration for empty data tables (warm admin palette). */
export function EmptyTableIllustration() {
  return (
    <svg
      className="admin-table-empty-svg"
      viewBox="0 0 280 188"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <linearGradient id="emptyTableCard" x1="44" y1="36" x2="220" y2="168" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fffefc" />
          <stop offset="1" stopColor="#f3ebe3" />
        </linearGradient>
        <linearGradient id="emptyTableAccent" x1="196" y1="28" x2="248" y2="92" gradientUnits="userSpaceOnUse">
          <stop stopColor="#f5c15c" />
          <stop offset="0.55" stopColor="#e86a24" />
          <stop offset="1" stopColor="#c55a1d" />
        </linearGradient>
        <linearGradient id="emptyTableStroke" x1="0" y1="0" x2="1" y2="1">
          <stop stopColor="#e86a24" stopOpacity="0.35" />
          <stop offset="1" stopColor="#8b3d12" stopOpacity="0.2" />
        </linearGradient>
        <filter id="emptyTableShadow" x="-8%" y="-8%" width="116%" height="116%" colorInterpolationFilters="sRGB">
          <feDropShadow dx="0" dy="10" stdDeviation="14" floodColor="#2d1a0a" floodOpacity="0.1" />
        </filter>
      </defs>

      <ellipse cx="138" cy="172" rx="102" ry="14" fill="#2d1f14" fillOpacity="0.06" />

      <g filter="url(#emptyTableShadow)">
        <rect x="46" y="44" width="188" height="124" rx="16" fill="url(#emptyTableCard)" stroke="url(#emptyTableStroke)" strokeWidth="1.25" />
      </g>

      <path
        d="M 72 84 H 208"
        stroke="#d4c4b8"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeDasharray="5 10"
        opacity="0.95"
      />
      <path
        d="M 72 108 H 208"
        stroke="#e0d5cd"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeDasharray="5 10"
        opacity="0.85"
      />
      <path
        d="M 72 132 H 156"
        stroke="#ebe3dd"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeDasharray="5 10"
        opacity="0.75"
      />

      <rect x="72" y="64" width="52" height="8" rx="4" fill="#e86a24" fillOpacity="0.2" />
      <rect x="130" y="64" width="34" height="8" rx="4" fill="#c4bbb2" fillOpacity="0.45" />

      <circle cx="222" cy="56" r="26" fill="url(#emptyTableAccent)" />
      <circle cx="222" cy="56" r="26" stroke="rgba(255,255,255,0.45)" strokeWidth="1.5" />
      <circle cx="210" cy="56" r="2.75" fill="#fffefc" fillOpacity="0.95" />
      <circle cx="222" cy="56" r="2.75" fill="#fffefc" fillOpacity="0.95" />
      <circle cx="234" cy="56" r="2.75" fill="#fffefc" fillOpacity="0.95" />

      <circle cx="40" cy="62" r="3" fill="#e86a24" fillOpacity="0.35" />
      <circle cx="52" cy="48" r="2" fill="#f5a623" fillOpacity="0.5" />
      <circle cx="236" cy="130" r="2.5" fill="#e86a24" fillOpacity="0.28" />
    </svg>
  );
}
